import * as React from "react";
import { forwardRef } from "react";
const SvgRadioCheckActive = (props, ref) => <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" ref={ref} {...props}><g fill="none"><circle cx={12} cy={12} r={12} fill="#FFF" /><path fill="#3B3C3F" d="m15.682 8.525 1.414 1.414-6.657 6.657-3.535-3.535 1.414-1.415 2.12 2.121z" /></g></svg>;
const ForwardRef = forwardRef(SvgRadioCheckActive);
export default ForwardRef;